import type {
  ActivityTrackingConfiguration,
  TrackerConfiguration,
} from '@snowplow/browser-tracker';

export const COMMON_TRACKER_CONFIG: TrackerConfiguration = {
  cookieSameSite: 'Lax',
  cookieSecure: true,
  discoverRootDomain: true,
  encodeBase64: true,
  stateStorageStrategy: 'cookieAndLocalStorage',
};

/** The minimum time that must have elapsed before first heartbeat */
export const MINIMUM_VISIT_LENGTH: ActivityTrackingConfiguration['minimumVisitLength'] = 30;
/** The interval at which the callback will be fired */
export const HEARTBEAT_DELAY: ActivityTrackingConfiguration['heartbeatDelay'] = 10;
